import * as React from 'react'
import Helmet from 'react-helmet'
import * as SiteConfig from '../../../data/SiteConfig'
import { Site } from '../../graphql-types'

const SEO = () => {
  const title = SiteConfig.siteTitle
  const siteUrl = SiteConfig.siteUrl
  const description = SiteConfig.siteDescription
  const image = siteUrl + '/card.png'
  const schemaOrgJSONLD = [
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      'url': siteUrl,
      'name': title,
    },
  ]

  return (
    <Helmet>
      {/* General tags */}
      <meta name='description' content={description} />
      <meta name='image' content={image} />

      {/* Schema.org tags */}
      <script type='application/ld+json'>
        {JSON.stringify(schemaOrgJSONLD)}
      </script>

      {/* OpenGraph tags */}
      <meta property='og:url' content={siteUrl} />
      <meta property='og:type' content='website' />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image} />

      {/* Twitter Card tags */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:site' content={SiteConfig.userTwitter} />
      <meta name='twitter:creator' content={SiteConfig.userTwitter} />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={image} />
    </Helmet>
  )
}

export default SEO



// WEBPACK FOOTER //
// ./src/components/SEO/SEO.tsx